export const errorData: Record<
  string,
  { title: string; description: string; primaryButton: string; secondaryButton: string }
> = {
  'pt-BR': {
    title: 'Houve um erro por aqui',
    description: 'Você pode tentar novamente mais tarde.',
    primaryButton: 'Tentar novamente',
    secondaryButton: 'Voltar',
  },
  'en-US': {
    title: 'Something went wrong',
    description: 'Unable to load terms and conditions. Please try again.',
    primaryButton: 'Try again',
    secondaryButton: 'Go back',
  },
  'es-ES': {
    title: 'Se ha producido un error',
    description: 'Por favor, inténtalo nuevamente.',
    primaryButton: 'Intentar de nuevo',
    secondaryButton: 'Volver',
  },
}
